import { FC } from 'react';
import { ReactComponent as Plus } from 'images/newIcons/plus.svg';

interface AddUserButtonProps {
  onClick: () => void;
}

const AddUserButton: FC<AddUserButtonProps> = ({ onClick }) => (
  <div
    className="flex items-center cursor-pointer w-fit ml-auto mr-2"
    onClick={onClick}
  >
    <span className="text-right text-xs font-semibold tracking-wider uppercase mt-1">
      добавить пользователя
    </span>
    <Plus className="w-[20px] h-[20px]" />
  </div>
);

export default AddUserButton;
